"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetModifyMultiple = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _TypeGuards = require("../../Utility/TypeGuards");

var _AssetModify = require("../AssetModify");

var _PreviewAsset = _interopRequireDefault(require("./PreviewAsset"));

var _AssetSaver = require("../AssetSaver");

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader/Loader"));

var _State = require("../../Utility/State");

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _ButtonGroup = _interopRequireDefault(require("@civicplus/preamble/lib/ButtonGroup"));

var _Alert = require("../../Utility/Alert");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AssetModifyMultiple = function AssetModifyMultiple(props) {
  var _items$current$select, _items$current$select2, _items$current$select3, _items$current$select4, _items$current$select5;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var items = (0, _react.useRef)([]);

  var _useState3 = (0, _react.useState)(_State.State.None),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var _useState5 = (0, _react.useState)(1),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      savedCount = _useState6[0],
      setSavedCount = _useState6[1];

  var failed = (0, _react.useRef)(new Map());
  var counter = (0, _react.useRef)(1);
  var success = (0, _react.useRef)([]);
  var totalCount = (0, _react.useRef)(props.files.length);

  function save(_x, _x2, _x3, _x4) {
    return _save.apply(this, arguments);
  }

  function _save() {
    _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(item, file, status, index) {
      var saver;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!success.current[index]) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              saver = new _AssetSaver.AssetSaver(props.config, item, file);
              _context.prev = 3;
              _context.next = 6;
              return saver.save(status);

            case 6:
              success.current[index] = true;
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              delete success.current[index];
              failed.current.set(index, _context.t0.message);
              return _context.abrupt("return");

            case 14:
              _context.prev = 14;
              counter.current++;
              setSavedCount(counter.current);
              return _context.finish(14);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9, 14, 18]]);
    }));
    return _save.apply(this, arguments);
  }

  function retrySave() {
    return _retrySave.apply(this, arguments);
  }

  function _retrySave() {
    _retrySave = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var saves, nextState;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setState(_State.State.Processing);
              counter.current = 1;
              setSavedCount(counter.current);
              totalCount.current = props.files.length - success.current.filter(function (x) {
                return x === true;
              }).length;
              saves = Array.from(failed.current.keys()).map(function (index) {
                return save(items.current[index], props.files[index], undefined, index);
              });
              failed.current = new Map();
              _context3.next = 8;
              return Promise.all(saves);

            case 8:
              nextState = failed.current.size === 0 ? _State.State.Finished : _State.State.Errored;
              setState(nextState);

              if (!(nextState === _State.State.Finished)) {
                _context3.next = 13;
                break;
              }

              _context3.next = 13;
              return (0, _Alert.runWithAlert)("Successfully saved asset(s).", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                var _props$onAssetSaved;

                return _regenerator["default"].wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        (_props$onAssetSaved = props.onAssetSaved) === null || _props$onAssetSaved === void 0 ? void 0 : _props$onAssetSaved.call(props);

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _retrySave.apply(this, arguments);
  }

  function onSave(_x5, _x6) {
    return _onSave.apply(this, arguments);
  }

  function _onSave() {
    _onSave = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(toSave, status) {
      var copy, saves, nextState;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              copy = function _copy(file, index) {
                var copyFirst = _objectSpread({}, items.current[0]);

                copyFirst.fileName = file.name;
                items.current[index] = copyFirst;
              };

              setState(_State.State.Processing);
              failed.current = new Map();
              counter.current = 1;
              setSavedCount(counter.current);
              saves = props.files.map(function (f, index) {
                // If theres no asset at the index, that means the user did not select it on the
                // left side to modify it. Since they didnt, we can assume it will have default values
                // and can make a copy of the first item.
                if (!items.current[index]) {
                  copy(f, index);
                }

                var modified = items.current[index];
                modified.notificationDetails = toSave.notificationDetails;
                modified.scheduleJob = toSave.scheduleJob;
                items.current[index] = modified;
                return save(items.current[index], f, status, index);
              });
              _context5.next = 8;
              return Promise.all(saves);

            case 8:
              totalCount.current = props.files.length - success.current.length;
              nextState = failed.current.size === 0 ? _State.State.Finished : _State.State.Errored;
              setState(nextState);

              if (!(nextState === _State.State.Finished)) {
                _context5.next = 14;
                break;
              }

              _context5.next = 14;
              return (0, _Alert.runWithAlert)("Successfully saved asset(s).", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                var _props$onAssetSaved2;

                return _regenerator["default"].wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        (_props$onAssetSaved2 = props.onAssetSaved) === null || _props$onAssetSaved2 === void 0 ? void 0 : _props$onAssetSaved2.call(props);

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));

            case 14:
              if (nextState === _State.State.Errored) {
                setSelected(Array.from(failed.current.keys())[0]);
              }

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _onSave.apply(this, arguments);
  }

  function onItemChanged(index, item) {
    items.current[index] = item;
  }

  function onPermissionSetChange(set, index) {
    items.current[index].permissionSet = set;
  }

  var failedItems = Array.from(failed.current.keys());
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    id: props.id,
    className: "prmbl-assetModifyMultiple",
    container: true,
    spacing: 24
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "asset-save-buttons"
  }), props.files.filter(function (w) {
    return !(0, _TypeGuards.isString)(w);
  }).filter(function (x, index) {
    // If the asset already saved successfully, remove it from the list.
    if (success.current[index]) {
      return null;
    } // otherwise, return them like normal


    return x;
  }).map(function (x) {
    return x;
  }).map(function (file, index) {
    var style = index === selected ? {
      backgroundColor: "grey"
    } : {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "prmbl-assetModifyMultiple-item ".concat(index === selected ? "selected" : ""),
      key: index,
      style: style,
      onClick: function onClick(e) {
        return setSelected(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        marginLeft: ".7em"
      }
    }, /*#__PURE__*/_react["default"].createElement(_PreviewAsset["default"], {
      file: file,
      config: props.config,
      height: 40,
      width: 40
    }), file.name));
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 8
  }, state === _State.State.None && /*#__PURE__*/_react["default"].createElement(_AssetModify.AssetModify, {
    key: ((_items$current$select = items.current[selected]) === null || _items$current$select === void 0 ? void 0 : _items$current$select.id) || ((_items$current$select2 = items.current[selected]) === null || _items$current$select2 === void 0 ? void 0 : _items$current$select2.fileName) || props.files[selected].name,
    trackingItem: items.current[selected],
    file: props.files[selected],
    portal: "asset-save-buttons",
    permissionSet: ((_items$current$select3 = items.current[selected]) === null || _items$current$select3 === void 0 ? void 0 : _items$current$select3.permissionSet) || props.permissionSet,
    onPermissionSetChange: onPermissionSetChange,
    categories: (_items$current$select4 = (_items$current$select5 = items.current[selected]) === null || _items$current$select5 === void 0 ? void 0 : _items$current$select5.categories) !== null && _items$current$select4 !== void 0 ? _items$current$select4 : props.categories,
    config: props.config,
    onItemChanged: onItemChanged,
    trackingIndex: selected,
    onSave: onSave,
    isNew: true,
    isMultipleUpload: true,
    disableSaveAndSend: true
  }), state === _State.State.Processing && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Loader["default"], null), /*#__PURE__*/_react["default"].createElement("h3", null, "Saving ", savedCount, " / ", totalCount.current, " asset(s).")), state === _State.State.Finished && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", null, "Successfully saved all asset(s).")), state === _State.State.Errored && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", null, failed.current.size, " asset(s) failed to upload, try again?"), failedItems.map(function (index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: items.current[index].fileName
    }, "Failed to upload: ", items.current[index].fileName, " -", " ", /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: "red"
      }
    }, failed.current.get(index)));
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: retrySave
  }, "Retry Upload"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      setState(_State.State.None);
    }
  }, "Modify Assets")))));
};

exports.AssetModifyMultiple = AssetModifyMultiple;